import { render, staticRenderFns } from "./PricePerUnitManYears.vue?vue&type=template&id=b0df4bde&scoped=true&"
import script from "./PricePerUnitManYears.vue?vue&type=script&lang=ts&"
export * from "./PricePerUnitManYears.vue?vue&type=script&lang=ts&"
import style0 from "./PricePerUnitManYears.vue?vue&type=style&index=0&id=b0df4bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0df4bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
